// These values should match the *names* of the custom field options,
const EInvoicingInvoiceStatusEnum = Object.freeze({
    CREATED: 'created',

    COMMS_FAILED: 'comms-failed',

    MAX_ATTEMPTS_REACHED: 'max-attempts-reached',

    FAILED: 'failed',
});

module.exports = EInvoicingInvoiceStatusEnum;
